import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import MDSpinner from 'react-md-spinner';
import {MetricsList} from './MetricsList';
import {Metric, MetricsFilter} from '../../models/Metric';
import {spinnerColor} from '../../utils/StyleUtils';
import {Template} from '../../models/Template';
import {updateMetricsFilter, updateOrderMetrics} from '../../actions/metrics';
import {bindActionCreators} from 'redux';
import {OrderIndex, OrderOptions} from '../../models/Common';
import {sortArray} from '../../utils/ArrayUtils';
import { FaSort } from "react-icons/fa";
import momentZ from 'moment-timezone';
import {TemplatesEventCount} from '../../reducers/templates';

interface StateProps {
  isLoadingMetrics: boolean,
  metrics: Metric[],
  orderParams: OrderOptions,
  metricsFilter: MetricsFilter,
}

interface DispatchProps {
  updateOrderMetrics: (orderParams: OrderOptions) => void
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps


const MetricsTabel = ({isLoadingMetrics, metrics, updateOrderMetrics, orderParams, metricsFilter}: Props) => {
  const [localOrderParams, setOrderParams] = useState(orderParams);
  const [localMetrics, setMetrics] = useState(metrics);

  useEffect(() => {
    setOrderParams(orderParams);
  }, [orderParams]);

  useEffect(() => {
    setMetrics(metrics);
  }, [metrics]);

  if (isLoadingMetrics) {
    return (
      <div className='spinner-container' style={{marginTop: 'auto', marginBottom: 'auto', width: '100%'}}>
        <MDSpinner size={100} singleColor={spinnerColor}/>
      </div>
    );
  }

  const changeOrderParams = (paramName: string) => {
    const newOrderParams: OrderOptions = {
      orderBy: paramName,
      orderIndex: localOrderParams.orderIndex === OrderIndex.ASC ? OrderIndex.DESC : OrderIndex.ASC
    }
    setOrderParams(newOrderParams)
    updateOrderMetrics(newOrderParams)
  }
  const renderOrder = (paramName: string) => {
    return <FaSort style={{opacity: paramName === localOrderParams.orderBy ? 1 : 0}}/>
  }

  const filterMetrics = (metrics: Metric[]) => {
    return metrics.filter(metric => {
      if(!metricsFilter.showIsFree && metric.isFree) {
        return false;
      }
      return momentZ(metric.createdAt).isAfter(momentZ().subtract(metricsFilter.createdFromDays, 'days'));
    })
  }

  return (
    <div className={'metrics-container'}>
      <div className={'reels-metrics-tabel'}>
        <div className={'header-tabel'}>
          <div className={'metrics-id-column header-right-border'}>#</div>
          <div className={'metrics-cover-column header-right-border'}>Cover</div>
          <div className={'metrics-name-column header-right-border'}>Template</div>
          <div className={'metrics-is-free-column header-right-border'}
               onClick={() => {changeOrderParams('isFree')}}
          >
            Free/Paid
            {renderOrder('isFree')}
          </div>
          <div className={'metrics-date-column header-right-border'}
               onClick={() => {changeOrderParams('createdAt')}}
          >
            Date
            {renderOrder('createdAt')}
          </div>
          <div className={'metrics-views-column header-right-border'}
               onClick={() => {changeOrderParams('viewsCount')}}
          >
            Views
            {renderOrder('viewsCount')}
          </div>
          <div className={'metrics-exports-column header-right-border'}
               onClick={() => {changeOrderParams('exportCount')}}
          >
            Exports
            {renderOrder('exportCount')}
          </div>
          <div className={'metrics-ratio-column header-right-border'}
               onClick={() => {changeOrderParams('exportToViewRatio')}}
          >
            Views/Export
            {renderOrder('exportToViewRatio')}
          </div>
          <div className={'metrics-popularity-column header-right-border'}
               onClick={() => {changeOrderParams('popularity')}}
          >
            Popularity
            {renderOrder('popularity')}
          </div>
        </div>
        <div style={{overflow: 'auto'}}>
            <MetricsList
              metrics={filterMetrics(sortArray(localMetrics, localOrderParams))}
            />
        </div>
        </div>
    </div>
  );
};

const templatesToMetrics = (
  templates: Template[],
  templatesViewCount: TemplatesEventCount,
  templatesExportPopularity: TemplatesEventCount,
  templatesExportCount: TemplatesEventCount,
): Metric[] => {
  return templates.map(template => {
    const viewsCount = templatesViewCount[template.id] ? templatesViewCount[template.id] : 0;
    const exportsCount = templatesExportCount[template.id] ? templatesExportCount[template.id] : 0;
    const popularity = templatesExportPopularity[template.id] ? Number(Number(templatesExportPopularity[template.id]).toFixed(4)) : 0;

    let exportToViewRatio = 0;
    if(templatesViewCount[template.id] && templatesExportCount[template.id]) {
      exportToViewRatio = Number(Number(viewsCount / exportsCount).toFixed(3));
    }

    return {
      id: template.id,
      name: `${template.artistName}:${template.trackName}`,
      cover: template.previewImageUrl,
      isFree: template.isFree,
      createdAt: template.createdAt,
      viewsCount,
      exportsCount,
      exportToViewRatio,
      popularity
    }
  })
}

const mapStateToProps = (state: any) => ({
  isLoadingMetrics: state.templates.isLoadingTemplates,
  metrics: templatesToMetrics(
    state.templates.templates,
    state.templates.templatesViewCount,
    state.templates.templatesExportPopularity,
    state.templates.templatesExportCount
  ),
  orderParams: state.metrics.orderParams,
  metricsFilter: state.metrics.metricsFilter,
});
const mapDispatchToProps = (dispatch: any) => ({
  updateOrderMetrics: bindActionCreators(updateOrderMetrics, dispatch),
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(MetricsTabel);
